<template>
<div>
    <h1 class="subtitle">Rendici&oacute;n | {{ codigo }}</h1>
    <div class="nj-cols">
        <div class="nj-card">
            <div class="nj-subtitle-1">Documentos</div>
            <div>
                <div class="headers">
                    <div class="item">N°</div>
                    <div class="item">Fecha</div>
                    <div class="item">DNI / RUC</div>
                    <div class="item">Razon social</div>
                    <div class="item">Descripcion</div>
                    <div class="item">Centro costo</div>
                    <div class="item">Tipo documento</div>
                    <div class="item">Serie</div>
                    <div class="item">N&uacute;mero</div>
                    <div class="item">Importe ( {{ moneda }} )</div>
                    <div class="item"></div>
                </div>
                <RendicionItem v-for="(documento, index) in documentos" :key="documento.id" :item="documento" :index="index + 1" @retirar="retirar" :centros_costo="centros_costo"
                    :tipos_documento="tipos_documento"></RendicionItem>
            </div>
            <br>
            <div class="nj-flx justify-between">
                <div class="nj-flx">
                    <button class="nj-button" @click="agregar()"><i class="mdi mdi-file-plus"></i>Agregar</button>
                    <b-upload v-model="file" @input="cargarArchivo">
                        <div class="nj-button"><i class="mdi mdi-folder-plus"></i>Cargar Masivo</div>
                    </b-upload>
                    <button class="nj-button" @click="borrarTodo()"><i class="mdi mdi-delete"></i>Borrar todo</button>
                    <button class="nj-button c-green" v-if="activarRegistrar" @click="registrar()"><i class="mdi mdi-content-save"></i>Registrar Documentos</button>
                </div>
                <div class="nj-flx">
                    <button class="nj-button" @click="descargarPlantilla()"><i class="mdi mdi-cloud-download"></i>Descargar Plantilla</button>
                    <button class="nj-button" @click="regresar()"><i class="mdi mdi-keyboard-backspace"></i>Regresar</button>
                </div>
            </div>
            <div class="nj-line"></div>

        </div>
        <div class="nj-card">
            <div class="nj-subtitle-1">Archivos Adjuntos</div>
            <b-upload v-if="activarRegistrar" v-model="pdf" @input="adjuntarPdf">
                <div class="nj-button"><i class="mdi mdi-file-pdf-box"></i>Adjuntar PDF (Max. 20 MB)</div>
            </b-upload>
            <br>
            <br>
            <a :href="caja.caj_url_pdf" v-if="caja && caja.caj_url_pdf" class="pdf-adjunto" target="_blank">
                <i class="mdi mdi-file-pdf-box"></i>
                <span>{{ caja.caj_url_pdf | file_name }}</span>
            </a>
        </div>
    </div>
</div>
</template>
<script>
import { mapActions } from "vuex"
import { estados } from "../../constants"
import { AppService, CajaService, RendicionService, ResponseStatus, UsuarioService } from "../../services"
import Environment from "../../services/Environment"
import Toast from "../../util/toast"
import RendicionItem from "./RendicionItem.vue"
export default {
    name: "RendicionNew",
    components: {
        RendicionItem
    },
    data() {
        return {
            caj_id: this.$route.params.id,
            caja: null,
            file: null,
            pdf: null,
            sequence: 0,
            documentos: [],
            centros_costo: [],
            tipos_documento: [],
        }
    },
    computed: {
        moneda() {
            return this.caja?.mon_simbolo
        },
        activarRegistrar() {
            if (this.caja) {
                if (this.caja.est_id == estados.RENDICION_APROBADA.id) {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        codigo() {
            return this.caja?.caj_codigo
        },
    },
    methods: {
        ...mapActions("AppStore", [
            "_loadingOn",
            "_loadingOff",
        ]),
        agregar() {
            this.documentos.push({
                id: this.sequence,
                red_fecha: "",
                red_dni_ruc: "",
                red_razon_social: "",
                red_descripcion: "",
                cec_codigo: "",
                red_tipo_documento: "",
                red_serie: "",
                red_numero: "",
                red_importe: 0,
            })
            this.sequence++
        },
        retirar(id) {
            this.documentos = this.documentos.filter(item => item.id != id)
        },
        cargarArchivo() {
            this._loadingOn()
            let counter = 1
            let interval = setInterval(() => {
                counter++
                if (this.file != null) {
                    RendicionService
                        .cargarArchivo(this.file, this.caj_id).then(
                            response => {
                                const data = response.data
                                data.forEach(documento => {
                                    documento.id = this.sequence
                                    this.sequence++
                                    this.documentos.push(documento)
                                })
                            },
                            error => {
                                Toast.error(error)
                                console.error(`error: `, error)
                            }
                        )
                    clearInterval(interval)
                }
                this.file = null
                this._loadingOff()
            }, 1000)
        },
        borrarTodo() {
            this.documentos = []
        },
        adjuntarPdf() {
            this._loadingOn()
            let counter = 1
            let interval = setInterval(() => {
                counter++
                if (this.pdf != null) {
                    RendicionService
                        .adjuntarPdf(this.pdf, this.caj_id).then(
                            response => {
                                Toast.success(response.message)
                                this.obtenerCaja()
                            },
                            error => {
                                Toast.error(error)
                                console.error(`error: `, error)
                            }
                        )
                    clearInterval(interval)
                }
                this.pdf = null
                this._loadingOff()
            }, 1000)
        },
        obtenerCaja() {
            CajaService
                .obtener({
                    caja: {
                        caj_id: this.caj_id
                    },
                    usuario: UsuarioService.getUsuario()
                }).then(
                    response => {
                        this.caja = response.data
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
        },
        obtenerRendiciones() {
            const rendicion = {
                caj_id: this.caj_id
            }
            RendicionService
                .obtenerRendiciones(rendicion).then(
                    response => {
                        if (response.data) {
                            response.data.lista_rendicion_detalle.forEach(documento => {
                                documento.id = this.sequence
                                this.sequence++
                                this.documentos.push(documento)
                            })
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
        },
        registrar() {
            const rendicion = {
                caj_id: this.caj_id
            }
            RendicionService
                .registrar(rendicion, this.documentos).then(
                    response => {
                        if (!response.data) {
                            Toast.success(response.message)
                            this.removerErrores()
                        } else {
                            Toast.error(response.message)
                            this.documentos = response.data.lista_rendicion_detalle
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
        },
        removerErrores() {
            this.documentos.forEach(item => {
                item.cec_flag = false
                item.tid_flag = false
            })
        },
        descargarPlantilla() {
            window.location.href = `${Environment.url}plantillas/rendicion/documentos.xlsx`
        },
        regresar() {
            this.$router.push(`/caja/view/${this.caj_id}`)
        },
    },
    mounted() {
        AppService
            .getData(["caja_estados", "centros_costo", "gerentes", "usuarios", "tipos_caja", "monedas", "tipos_documento"])
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.centros_costo = response.data.centros_costo
                    this.tipos_documento = response.data.tipos_documento
                    this.obtenerCaja()
                    this.obtenerRendiciones()
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    },
}
</script>
<style scoped>
.headers {
    display: grid;
    grid-template-columns: 40px 100px 120px repeat(2, 1fr) 200px 200px 100px 100px 100px 40px;
    align-items: center;
    border: 1px solid #0077b6 !important;
    background-color: #0077b6 !important;
    color: #fff;
}

.headers>.item {
    padding: 6px;
}

.pdf-adjunto {
    border: 1px solid #ea4335;
    background-color: #ea4335;
    border-radius: 2px;
    display: inline-flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    padding: 8px;
}

.pdf-adjunto * {
    color: #fff;
}

.pdf-adjunto i {
    font-size: 32px;
}

.pdf-adjunto:hover,
.pdf-adjunto:visited {
    color: unset;
}
</style>